import { useState } from "react";
import { Avatar, Popover } from "antd";
import { Auth } from "aws-amplify";
import { useUser } from "../../services/auth";
import classNames from "./UserMenu.module.css";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

function UserMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { email: username } = useUser();
  const logout = () => Auth.signOut();
  const user = username ? username.split("@")[0] : "";
  if (user) {
    return (
      <Popover
        className={classNames.userMenuPopover}
        trigger="click"
        placement="bottomRight"
        content={
          <div
            role="button"
            tabIndex={0}
            className={classNames.userMenuMenuItem}
            onClick={logout}
            onKeyDown={logout}
          >
            <LogoutOutlined style={{ marginRight: 8 }} />
            Log out
          </div>
        }
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ marginBottom: 0, marginRight: 8 }}>{user}</p>
          <Avatar icon={<UserOutlined />} size="large" />
        </div>
      </Popover>
    );
  }
  return null;
}

export default UserMenu;
